// extracted by mini-css-extract-plugin
export var avatar = "_na-3";
export var avatarContainer = "_na-2";
export var avatarSpacer = "_na-5";
export var avatarSpacerContainer = "_na-4";
export var avatarStackContainer = "_na-1";
export var bubble = "_na-0";
export var remainderBubble = "_na-6";